export const CheckIconV2 = (props) => (
  <svg fill="none" height={13} viewBox="0 0 14 13" width={14} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.4484 1.43588L4.68548 9.19877L1.15689 5.67019M13.1541 12.0216H0.451172"
      stroke={props.color ? props.color : "white"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.907351}
    />
  </svg>
);
